import row1 from './cards.row1.json';
import row2 from './cards.row2.json';
import row3 from './cards.row3.json';
import row4 from './cards.row4.json';
import row5 from './cards.row5.json';
import type { CardTemplate } from '../types';

export const cardPools: CardTemplate[][] = [
  row1 as CardTemplate[],
  row2 as CardTemplate[],
  row3 as CardTemplate[],
  row4 as CardTemplate[],
  row5 as CardTemplate[],
];
